import { render } from "./ModuleUnderDevelopment.vue?vue&type=template&id=6718f751&scoped=true"
import script from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"
export * from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"

import "./ModuleUnderDevelopment.vue?vue&type=style&index=0&id=6718f751&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6718f751"]])

export default __exports__